module.exports = __webpack_public_path__ + "static/media/donate-yellow-kn.f90d3a07.svg";